import { myAxios } from "./axios"

export function getCountries(data, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            title: data ? data.txt : null,
        },
    }
    return myAxios.get("/countries", config)
}


export function getCountry(id) {
    return myAxios.get("/countries/" + id)
}

export function addCountry(data) {
    return myAxios.post("/countries/create", data)
}

export function editCountry(id, data) {
    return myAxios.put("/countries/" + id + "/update", data)
}

export function deleteCountry(id) {
    return myAxios.delete("/countries/" + id + "/delete")
}

export function publishCountry(id, data) {
    if (data.type === "publish") {
        return myAxios.post("/countries/" + id + "/publish")
    } else {
        return myAxios.post("/countries/" + id + "/unpublish")
    }
}


export function importCountrys(data) {
    return myAxios.post("/countries/import", data)
}